// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__jm7gE","header":"ReportDetails_header__2ywAd","title":"ReportDetails_title__2JwHL","left":"ReportDetails_left__2xRlM"};